import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withApp, scrollTop } from 'helpers'
import { withRouter, Redirect } from 'react-router-dom'
import { Endtest } from 'content'
import IntroIntro from './components/IntroIntro'
import IntroPage from './components/IntroPage'

class EndtestIntroView extends React.Component {
  componentDidMount() {
    if(!this.props.endtest.intro) return

    scrollTop()
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  render() {
    if(!this.props.endtest.intro)
      return <Redirect to={Routes.to('endtestTest')} />

    if(this.props.endtest.intro.type === 'intro')
      return (<IntroIntro />)

    if(this.props.endtest.intro.type === 'page')
      return (<IntroPage />)
  }
}

export default withRouter(withApp(connect(
  (state, props) => ({
    endtest: Endtest,
    navigation: state.content.navigation,
  }),
  (dispatch) => ({})
)(EndtestIntroView)))



// WEBPACK FOOTER //
// ./src/components/views/endtest/EndtestIntroView.js